import { useState } from 'react';
import { KeyRound, ShieldCheck, User, Image } from 'lucide-react';

import DefaultLayout from '../layout/DefaultLayout';

import PersonalInfo from '../auth/ProfileSettings/PersonalInfo';
import ChangePassword from '../auth/ProfileSettings/ChangePassword';
import ProfilePhoto from '../auth/ProfileSettings/ProfilePhoto';

import BreadcrumbTwo from '../components/Breadcrumbs/BreadcrumbTwo';

import { useAuth } from '../auth/hooks/useAuth';
import TwoFactorAuth from '../components/twoFactorAuth/TwoFactorAuth.tsx';

const TABS = [
  { key: 'personalInfo', label: 'Información Personal', icon: User },
  { key: 'changePassword', label: 'Cambiar Contraseña', icon: KeyRound },
  { key: 'profilePhoto', label: 'Foto de Perfil', icon: Image },
  { key: 'googleAuthenticator', label: 'Autenticación 2FA', icon: ShieldCheck },
] as const;

const Profile = () => {
  const [activeTab, setActiveTab] =
    useState<(typeof TABS)[number]['key']>('personalInfo');

  const { auth } = useAuth();

  const renderContent = () => {
    switch (activeTab) {
      case 'personalInfo':
        return <PersonalInfo />;
      case 'changePassword':
        return <ChangePassword />;
      case 'profilePhoto':
        return <ProfilePhoto />;
      case 'googleAuthenticator':
        return <TwoFactorAuth email={auth.email} />;
      default:
        return null;
    }
  };

  return (
    <DefaultLayout>
      <div className="mx-auto max-w-7xl">
        <BreadcrumbTwo />

        <div className="grid grid-cols-1 gap-6 xl:grid-cols-12">
          {/* Sidebar */}
          <div className="xl:col-span-4">
            <div className="overflow-hidden rounded-lg border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
              <div className="border-b border-stroke px-6 py-5 dark:border-strokedark">
                <h3 className="text-title-xsm font-semibold text-black dark:text-white">
                  Configuración
                </h3>
                <p className="mt-1 text-sm text-body dark:text-bodydark">
                  Administra tu cuenta y preferencias
                </p>
              </div>

              <div className="space-y-1.5 p-4">
                {TABS.map((tab) => {
                  const isActive = activeTab === tab.key;
                  const Icon = tab.icon;
                  return (
                    <button
                      key={tab.key}
                      onClick={() => setActiveTab(tab.key)}
                      className={`flex w-full items-center gap-3 rounded-md px-4 py-3 text-left text-sm font-medium transition-all duration-200 ${
                        isActive
                          ? 'bg-primary text-white shadow-sm'
                          : 'text-black hover:bg-gray hover:text-primary dark:text-white dark:hover:bg-meta-4'
                      }`}
                    >
                      <Icon className="h-4 w-4 shrink-0" />
                      {tab.label}
                    </button>
                  );
                })}
              </div>
            </div>
          </div>

          {/* Contenido */}
          <div className="xl:col-span-8">
            <div className="rounded-lg border border-stroke bg-white p-6 shadow-default dark:border-strokedark dark:bg-boxdark">
              {renderContent()}
            </div>
          </div>
        </div>
      </div>
    </DefaultLayout>
  );
};

export default Profile;
